import React from 'react'
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
const ModuleNav = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    return (
        <div className='pt-8 pb-4' >
            <p className={`text-sm font-bold text-white text-left hover:cursor-pointer`} onClick={() => navigate('/?render=0')} >
                {t(`overview_module_start`)}
            </p>
            <p className={`text-sm font-bold text-white text-left hover:cursor-pointer`} onClick={() => navigate('/level-one?render=0')} >
                {t(`overview_module_1`)}
            </p>
            <p className={`text-sm font-bold text-white text-left hover:cursor-pointer`} onClick={() => navigate('/level-two?render=0')}>
                {t(`overview_module_2`)}
            </p>
            <p className={`text-sm font-bold text-white text-left hover:cursor-pointer`} onClick={() => navigate('/level-three?render=0')}>
                {t(`overview_module_3`)}
            </p>
            <p className={`text-sm font-bold text-white text-left hover:cursor-pointer`} onClick={() => navigate('/level-four?render=0')}>
                {t(`overview_module_4`)}
            </p>
            <p className={`text-sm font-bold text-white text-left hover:cursor-pointer`} onClick={() => navigate('/level-five?render=0')}>
                {t(`overview_module_5`)}
            </p>
            <p className={`text-sm font-bold text-white text-left hover:cursor-pointer`} onClick={() => navigate('/level-six?render=0')}>
                {t(`overview_module_6`)}
            </p>
        </div>
    )
}

export default ModuleNav
